import React, { Component } from 'react';
class LeaveEmpList extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){

}


  render() {
    return (
        <>
        <div className="col-md-4">
          <div className="container mt-4">
            <div className="accordion" id="spryTabs">
              <div className="accordion-item" id="tab-2">
                <h2 className="accordion-header" id="headingOne">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#LeaveEmpList" aria-expanded="false" aria-controls="collapseOne">
                    Employee on leave
                  </button>
                </h2>
                <div id="LeaveEmpList" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#spryTabs">
                  <div className="accordion-body background-white calendar_card">
                    <p className="ms-4">Satish Pethkar</p>
                  </div>
                </div>
                </div>
                </div>
          </div>
        </div>

        </>
    );
  }
}

export default LeaveEmpList;
